export default {
  header: {
    collection: 'Colección',
    discord: 'Únete a Discord',
    twitter: 'Síguenos en Twitter',
  },
  landing: {
    discover: 'Descubre',
    nodeRocks: 'NODE_ROCKS',
    onBitcoin: 'en Bitcoin',
    searchPlaceholder: 'Ingresa ID de Rock...',
    viewDetails: 'Ver Detalles',
  },
  story: {
    title: 'La Historia Detrás de NodeRocks',
    description: 'NodeRocks comenzó en diciembre, creado por un desarrollador conocido como {{developer}}. Sin embargo, cuando el proyecto enfrentó un posible rug pull, la comunidad se negó a dejarlo morir. En cambio, se unieron, tomaron el control y comenzaron a reconstruir el proyecto desde cero.',
    community: 'La comunidad rápidamente obtuvo acceso al portal de desarrolladores de {{platform}} y lanzó nuevos canales de redes sociales para reconectarse y crecer. En pocas semanas, NodeRocks era más fuerte que nunca, y la comunidad comenzó a construir características emocionantes como su propia plataforma de staking, explorador e incluso creando música para el proyecto.',
    conclusion: 'NodeRocks es ahora el primer proyecto 100% impulsado por la comunidad en el espacio de Ordinals, un testimonio del poder de una comunidad apasionada que se une para llevar el proyecto a nuevas alturas. De casi colapsar a una comunidad próspera e innovadora, NodeRocks se ha convertido en un símbolo de resiliencia y creatividad en el mundo de Bitcoin Ordinals.',
  },
  yinYang: {
    title: 'Inscripciones Yin Yang',
    subtitle: 'Símbolo de Armonía en Bitcoin para siempre en la cadena',
    history: {
      title: 'Historia',
      description: 'Entre las Inscripciones Malditas, surgió un fenómeno único cuando las inscripciones {{positive}} y {{negative}} se vincularon al mismo satoshi. Este emparejamiento llegó a simbolizar la dualidad y la armonía, inspirándose en la antigua filosofía china del Yin y el Yang.',
    },
    rarity: {
      title: '¿Qué tan Raras son las Inscripciones Yin Yang?',
      description: 'Solo hay {{count}} inscripciones Yin Yang para siempre en Bitcoin, lo que las convierte en un subconjunto increíblemente raro de las {{total}} Inscripciones Malditas totales. Su creación cesó después del {{block}} en 2024, solidificando su rareza.',
    },
  },
  cursedRocks: {
    title: 'La Dualidad de las Rocas Malditas',
    subtitle: 'Un Capítulo Único en Bitcoin Ordinals',
    normal: 'Normal',
    cursed: 'Maldita',
    hoverReveal: 'Pasa el cursor para revelar la maldición',
    whatAre: {
      title: '¿Rocas Malditas?',
      description: 'Cada NodeRock viene con su contraparte Maldita, ya que ambas están almacenadas de manera única en el mismo satoshi. El NodeRock representa la inscripción positiva, mientras que la Roca Maldita sirve como su contraparte negativa. Juntas, forman un perfecto equilibrio Yin Yang, simbolizando la dualidad e interconexión.',
    },
    rarity: {
      title: 'Rareza y Valor',
      description: 'NodeRocks es la primera colección en ofrecer un concepto de Compra 1, Obtén 2, donde cada NodeRock viene con su Roca Maldita emparejada, formando un equilibrio Yin Yang. Con solo 70,000 inscripciones Yin Yang creadas, nunca habrá nuevas inscripciones Yin Yang, lo que hace que cada par sea un activo exclusivo y raro.',
    },
  },
  laboratory: {
    title: '¡HAZ STAKE DE TUS NODEROCKS!',
    stakeNow: 'HACER STAKE AHORA',
  },
  showcase: {
    title: 'Muestra Tu Rock',
    subtitle: 'Únete a la revolución del arte digital en Bitcoin',
    viewCollection: 'Ver Colección Completa',
  },
  footer: {
    language: 'Idioma',
    selectLanguage: 'Seleccionar Idioma',
    links: 'Enlaces Rápidos',
    marketplace: 'Mercado Magic Eden',
    discord: 'Unirse a Discord',
    twitter: 'Seguir en Twitter',
    community: 'Comunidad',
    rights: 'Todos los derechos reservados.',
  },
};